import {
    Container,
    Paper,
    Typography,
    Box,
    Button,
    FormControl,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio,
    Checkbox,
    FormGroup,
    FormHelperText
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
export default function StudentLoanForm({

    data,

    errors,

    handleChange,

    handleCheckboxChange,

    onBack,

    onContinue

}) {

    return (
            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography
                    variant="h4"
                    gutterBottom
                >

                    Student Loan

                </Typography>

                <Typography
                    sx={{ mb: 4 , color: "rgba(0,0,0,0.6)",}}
                >

                    Please provide your Student Loan information.

                </Typography>


                <FormControl
                    error={!!errors.isStudentLoanDeductionExempt}
                    sx={{ mb: 4 }}
                >

                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                        Do any of the following statements apply to you?

                    </FormLabel>
                    <Box
                        component="ul"
                        sx={{
                            pl: 3,
                            mb: 2,
                        }}
                    >
                        <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                            You do not have any Student or Postgraduate loans.
                        </Typography>

                        <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                            You're still studying full-time on a course that your Student Loan relates to.
                        </Typography>

                        <Typography component="li" variant="body2" sx={{ mb: 1 }}>
                            You completed or left your full-time course after the start of the current tax year, which started on 6 April.
                        </Typography>

                        <Typography component="li" variant="body2">
                            You're already making regular direct debit repayments from your bank, as agreed with the Student Loans Company.
                        </Typography>
                    </Box>

                    <RadioGroup

                        row

                        name="isStudentLoanDeductionExempt"

                        value={data.isStudentLoanDeductionExempt}

                        onChange={handleChange}

                    >

                        <FormControlLabel

                            value="true"

                            control={<Radio />}

                            label="Yes"

                        />


                        <FormControlLabel

                            value="false"

                            control={<Radio />}

                            label="No"

                        />

                    </RadioGroup>


                    <FormHelperText>

                        {errors.isStudentLoanDeductionExempt}

                    </FormHelperText>

                </FormControl>



                {
                    data.isStudentLoanDeductionExempt === "false" && (

                        <Box sx={{ mb: 4 }}>

                            <Typography variant="body2" gutterBottom sx={{ fontSize: "1rem", }}>
                                Which Student Loan deductions apply to you? Select all that apply.
                            </Typography>


                            <FormGroup>

                                <FormControlLabel

                                    control={

                                        <Checkbox

                                            name="plan1"

                                            checked={data.plan1}

                                            onChange={
                                                handleCheckboxChange
                                            }

                                        />

                                    }

                                    label="Plan 1"

                                />


                                <FormControlLabel

                                    control={

                                        <Checkbox

                                            name="plan2"

                                            checked={data.plan2}

                                            onChange={
                                                handleCheckboxChange
                                            }

                                        />

                                    }

                                    label="Plan 2"

                                />


                                <FormControlLabel

                                    control={

                                        <Checkbox

                                            name="plan4"

                                            checked={data.plan4}

                                            onChange={
                                                handleCheckboxChange
                                            }

                                        />

                                    }

                                    label="Plan 4"

                                />


                                <FormControlLabel

                                    control={

                                        <Checkbox

                                            name="postgradLoan"

                                            checked={data.postgradLoan}

                                            onChange={
                                                handleCheckboxChange
                                            }

                                        />

                                    }

                                    label="Postgraduate Loan"

                                />

                            </FormGroup>


                            {
                                errors.loanPlans && (

                                    <FormHelperText error>

                                        {errors.loanPlans}

                                    </FormHelperText>

                                )
                            }

                        </Box>

                    )
                }



                <Box

                    sx={{

                        display: "flex",

                        justifyContent: "space-between",

                        mt: 5

                    }}

                >

                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>

                </Box>

            </Paper>


    );

}